import { HandsLove as o } from "./hands-love.js";
import { HandsPeace as r } from "./hands-peace.js";
import { HandsSwear as m } from "./hands-swear.js";
import { HandsStarTrek as a } from "./hands-star-trek.js";
import { HandsTouch as t } from "./hands-touch.js";
import { Hands00000 as n } from "./hands-00000.js";
import { Hands00001 as s } from "./hands-00001.js";
import { Hands01110 as d } from "./hands-01110.js";
import { Hands10000 as p } from "./hands-10000.js";
import { Hands10001 as H } from "./hands-10001.js";
import { Hands11110 as f } from "./hands-11110.js";
import { Hands11000 as i } from "./hands-11000.js";
import { Hands11100 as e } from "./hands-11100.js";
import { Hands11111 as c } from "./hands-11111.js";
import { Hands111112 as S } from "./hands-11111-2.js";
import { Hands11101 as T } from "./hands-11101.js";
import { Hands00011 as h } from "./hands-00011.js";
import { Hands00111 as k } from "./hands-00111.js";
import { Hands01001 as u } from "./hands-01001.js";
import { Hands01000 as v } from "./hands-01000.js";
import { Hands01100 as w } from "./hands-01100.js";
import { Hands00100 as x } from "./hands-00100.js";
import { Hands01111 as L } from "./hands-01111.js";
import { Hands110002 as P } from "./hands-11000-2.js";
const W = {
  HandsLove: o,
  HandsPeace: r,
  HandsSwear: m,
  HandsStarTrek: a,
  HandsTouch: t,
  Hands00000: n,
  Hands00001: s,
  Hands01110: d,
  Hands10000: p,
  Hands10001: H,
  Hands11110: f,
  Hands11000: i,
  Hands11100: e,
  Hands11111: c,
  Hands111112: S,
  Hands11101: T,
  Hands00011: h,
  Hands00111: k,
  Hands01001: u,
  Hands01000: v,
  Hands01100: w,
  Hands00100: x,
  Hands01111: L,
  Hands110002: P
};
export {
  W as Hands
};
